import React, { FC, useEffect, useRef } from "react";
import styles from "./Modals.module.css";
import Close from "Utils/Assets/SVGs/Close";
import AddDeliveryAddressModalForm from "../Forms/AddDeliveryAddressModalForm";
import { AddDeliveryAddressModalProps } from "@model/DeliveryAddress.model";
import { DeliveryAddressService } from "Logic/DeliveryAddressService";

const AddDeliveryAddressModal: FC<AddDeliveryAddressModalProps> = ({ open, token, onClose, onCreated }) => {
  const dialogRef = useRef<HTMLDivElement | null>(null);
  const timeoutRef = useRef<number | null>(null);
  const service = new DeliveryAddressService();

  useEffect(() => {
    return service.handleModalFocus({ open, dialogRef, timeoutRef });
  }, [open]);

  if (!open) return null;

  return (
    <div
      className={styles.mcdBackdrop}
      role="presentation"
      onMouseDown={onClose}
      data-testid="add-address-backdrop"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="add-address-title"
        className={styles.mcdModal}
        onMouseDown={(e) => e.stopPropagation()}
        tabIndex={-1}
        ref={dialogRef}
        data-testid="add-address-modal"
      >
        <header className={styles.mcdHead}>
          <h2 id="add-address-title" className={styles.mcdTitle}>
            Add delivery address
          </h2>

          <button
            type="button"
            className={styles.mcdIconBtn}
            onClick={onClose}
            aria-label="Close"
            data-testid="add-address-close"
          >
            <Close className={styles.mcdCloseIcon} />
          </button>
        </header>

        <div className={styles.mcdBody}>
          <AddDeliveryAddressModalForm token={token} onClose={onClose} onCreated={onCreated} />
        </div>
      </div>
    </div>
  );
};

export default AddDeliveryAddressModal;
